import { stateMapperArgsSelectors } from '#packages/stateManagement';

export const {
  dsReadSel,
  editorAPIMouseSel,
  editorAPISel,
  editorStateSel,
  editorStateMouseOpsSel,
  getStateMapperArgsFromEditorAPI,
} = stateMapperArgsSelectors.rootSels;
